import React from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import "react-datepicker/dist/react-datepicker.css"
import ReactDOM from "react-dom"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"

import { queryClient } from "./config/queryClient"

import store from "./redux/store"
import { Provider } from "react-redux"

import App from "./App"
import "./index.css"
import reportWebVitals from "./reportWebVitals"

const rootElement = document.getElementById("root")
const app = (
   <React.StrictMode>
      <HelmetProvider>
         <QueryClientProvider client={queryClient}>
            <BrowserRouter>
               <Provider store={store}>
                  <App />
               </Provider>
            </BrowserRouter>
         </QueryClientProvider>
      </HelmetProvider>
   </React.StrictMode>
)

// react-snap prerenders pages into static HTML; hydrate that markup instead of
// re-rendering from scratch when it's present, otherwise render normally
if (rootElement.hasChildNodes()) {
   ReactDOM.hydrate(app, rootElement)
} else {
   ReactDOM.render(app, rootElement)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
